export default __webpack_public_path__ + "static/media/cartpanda_logo.cf4222c3.png";